import { render, staticRenderFns } from "./CrudVATTypeRates.vue?vue&type=template&id=7596aad5&scoped=true"
import script from "./CrudVATTypeRates.vue?vue&type=script&lang=js"
export * from "./CrudVATTypeRates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7596aad5",
  null
  
)

export default component.exports